import { useMutation } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { MOSAIC_CONFIGURATION_API } from '../../constants';
export var useMosaicConfigurationMutation = function () {
    var ky = useOkapiKy();
    var _a = useMutation({
        mutationFn: function (_a) {
            var config = _a.config;
            return config.id
                ? ky.put(MOSAIC_CONFIGURATION_API, { json: config }).json()
                : ky.post(MOSAIC_CONFIGURATION_API, { json: config }).json();
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading;
    return {
        isLoading: isLoading,
        mutateAsync: mutateAsync,
    };
};
